// 5.38.0 client follow-ups — small shared helpers (tested in followups.test.js).
import { MAIN_WINDOW_NAME, requestOpenClient } from './insuredocsChannel';
import { addDays, todayWall } from './calendarTime';

// Open a client's MAIN folder in the InsureDocs window: ask an open InsureDocs tab first (no reload, unsaved work
// asks there), otherwise open /?client=<id> in the named main window (Main opens that client by id after login).
export async function openClientInMain(clientId) {
  const id = Number(clientId);
  if (!Number.isInteger(id) || id <= 0) return;
  if (await requestOpenClient(id)) {
    try { window.open('', MAIN_WINDOW_NAME); } catch (_e) { /* focus is best effort */ }
    return;
  }
  window.open(`/?client=${id}`, MAIN_WINDOW_NAME);
}

// 5.42.0 follow-ups from Solutions ACORD forms. ACORD keeps standard / carrier / custom forms in separate tables whose
// ids collide, so a form is ALWAYS (type, id); each type has its own address parameter on ACORD's page.
export const FORM_PARAM = { acord: 'form', carrier: 'carrier', custom: 'custom' };
export const FORM_LABEL = { acord: 'ACORD', carrier: 'Carrier', custom: 'Custom' };
export const ACORD_WINDOW_NAME = 'insuredocs-acord';

export function formHref(formType, formId) {
  const p = FORM_PARAM[formType];
  const id = Number(formId);
  if (!p || !Number.isInteger(id) || id <= 0) return null;
  return `/acord/?${p}=${id}`;
}

// Open that exact form in ACORD (one reused ACORD tab). ACORD's own sign-in bounce keeps the address.
export function openFormInAcord(formType, formId) {
  const href = formHref(formType, formId);
  if (href) window.open(href, ACORD_WINDOW_NAME);
}

// "Calendar tab" address that opens a follow-up: events on their day with the dialog, tasks on the Tasks tab;
// `user` = someone else's calendar (admins only — the server checks).
export function followupHref(row, me) {
  const u = row.owner && row.owner.username !== me ? `&user=${encodeURIComponent(row.owner.username)}` : '';
  if (row.kind === 'task') return `/?calendar=1&tab=tasks${u}`;
  const day = (row.start || '').slice(0, 10);
  return `/?calendar=1${day ? `&day=${day}` : ''}${row.object_id ? `&event=${row.object_id}` : ''}${u}`;
}

const fmtDay = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
const fmtTime = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', hour: 'numeric', minute: '2-digit' });
// "Wed, Nov 4, 2026 11:00 AM" / "Thu, Nov 5, 2026" (Chicago wall strings)
export function whenLabel(s) {
  if (!s) return 'No due date';
  const d = new Date(`${s.length === 10 ? `${s}T00:00:00` : s}Z`);
  return s.length === 10 ? fmtDay.format(d) : `${fmtDay.format(d)} ${fmtTime.format(d)}`;
}

export const minutesBetween = (a, b) => Math.round((new Date(`${b}Z`) - new Date(`${a}Z`)) / 60000);
export function addMinutes(wall, mins) {
  const d = new Date(`${wall}Z`);
  d.setUTCMinutes(d.getUTCMinutes() + mins);
  return d.toISOString().slice(0, 19);
}
export const tomorrowWall = () => addDays(todayWall(), 1);
